import React, { useEffect, useRef, useState } from "react";
import { isEmptyString } from "../../helperFunc";
import { useEditReleaseNotesMutation } from "../../redux/catalogueService";
import {
  useGetReleaseNotesQuery,
  useLazyGetReleaseNotesQuery,
} from "../../redux/searchService";
import Modal from "../Modal/Modal";
import useModal from "../Modal/useModal";
import ReactMarkdown from "react-markdown";
import { FaEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { MdNewReleases } from "react-icons/md";
import Authorization from "../Authorization/Authorization";
import remarkSubSuper from "remark-supersub";

const ReleaseNote = ({ dataReleaseFilter, releaseName, setReleaseName }) => {
  const [togglePreview, setTogglePreview] = useState(false);
  const [releaseNote, setReleaseNote] = useState();
  const [editReleaseNotes] = useEditReleaseNotesMutation();
  const [trigger, result] = useLazyGetReleaseNotesQuery();
  const editRef = useRef(null);
  const {
    isShowing: isEditReleaseNoteModalShowing,
    openModal: openEditReleaseNoteModal,
    closeModal: closeEditReleaseNoteModal,
  } = useModal();
  const itemRefs = dataReleaseFilter?.options.reduce((acc, current) => {
    acc[current.value] = React.createRef();
    return acc;
  }, {});

  const handleListItemClick = (value) =>
    itemRefs[value]?.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

  const scroll = () => handleListItemClick(releaseName);
  useEffect(() => {
    if (isEmptyString(releaseName) || releaseName == null) return;
    trigger(releaseName, true);
    scroll();
  }, [releaseName]);

  useEffect(() => {
    if (result?.data) setReleaseNote(result?.data);
  }, [result])

  const previewHandler = () => {
    setTogglePreview(true);
    setReleaseNote(editRef.current.value);
  };

  const releaseNoteClickHandler = (e, value) => {
    setReleaseName(value);
  };

  const editHandler = async () => {
    await editReleaseNotes({
      releaseName,
      releaseNote: {
        content: editRef.current.value,
      },
    });
    setTogglePreview(false);
  };
  return (
    <>
      <Modal
        isShowing={isEditReleaseNoteModalShowing}
        close={closeEditReleaseNoteModal}
        title="Edit Release Note"
        onConfirm={editHandler}
        customClass="edit-modal"
      >
        <div className="release-note-text">
          <h4>Release Note</h4>
          <textarea
            id="release-note"
            name="release-note"
            rows="15"
            cols="60"
            ref={editRef}
            title="release-note-mkdwn"
            defaultValue={releaseNote}
          />
        </div>

        <button className="preview bg-green-button" onClick={previewHandler}>
          Generate Preview
        </button>
        {togglePreview && (
          <div className="preview-box">
            <h4>
              Markdown Preview
              <ImCross
                style={{ width: "15px", cursor: "pointer", margin: "2px 10px" }}
                onClick={() => setTogglePreview(false)}
              ></ImCross>
            </h4>
            <div> {
                <ReactMarkdown
                  children={releaseNote}
                  remarkPlugins={[remarkSubSuper]}
                />
              }
            </div>
          </div>
        )}
      </Modal>
      <div className="release-note-container">
        <h3>Release Notes</h3>
        <div className="release-note-section">
          <ul className="dr-list">
            {dataReleaseFilter.options.map((dataRelease, index) => {
              return (
                <li
                  className={
                    dataRelease.value === releaseName ? "note clicked" : ""
                  }
                  onClick={(e) => releaseNoteClickHandler(e, dataRelease.value)}
                  key={index}
                  ref={itemRefs[dataRelease.value]}
                >
                  <span>{dataRelease.name}</span>{" "}
                  {!dataRelease.signedOff && (
                    <span>
                      <MdNewReleases width={20} height={20} style={{ marginTop: "4px" }} />
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
          <div className="release-note-mkdwn">
            <Authorization>
              <div className="release-note-buttons">
                <FaEdit
                  title="edit-btn"
                  onClick={openEditReleaseNoteModal}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "15px",
                    width: "30px",
                    height: "20px",
                    color: "#6b6d67",
                    cursor: "pointer",
                  }}
                />
              </div>
            </Authorization>
            <div className="release-note">
              {<ReactMarkdown
                  children={releaseNote}
                  remarkPlugins={[remarkSubSuper]}
                />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReleaseNote;
